import React from "react";
import Tooltip, { TooltipProps } from "@material-ui/core/Tooltip";
import { useStylesInfoTooltip } from "./info-tooltip.styles";

export const InfoTooltip = (props: TooltipProps) => {
  const classes = useStylesInfoTooltip();
  return <Tooltip arrow classes={classes} {...props} />;
};
